/**
 * Build canonical in-app help deep links.
 */
export function buildHelpFeaturesPath(helpSectionId) {
  const normalizedId = String(helpSectionId || "").trim();
  if (!normalizedId) return "/help/features";
  return `/help/features#${normalizedId}`;
}

export function getFeatureHelpPath(item) {
  return buildHelpFeaturesPath(item?.helpSectionId || item?.id);
}
